import { render, staticRenderFns } from "./CalendarioHistorico.vue?vue&type=template&id=0831fe19&scoped=true&"
import script from "./CalendarioHistorico.vue?vue&type=script&lang=ts&"
export * from "./CalendarioHistorico.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarioHistorico.vue?vue&type=style&index=0&id=0831fe19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831fe19",
  null
  
)

export default component.exports